import type { QueryKey } from "@tanstack/react-query";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useSnackbar } from "notistack";
import type { AddInvoiceBatchRequest, AddCostInvoiceBatchResponse } from "./costApi";
import { addInvoiceToCosts } from "./costApi";

export const useCostsInvoice = () => {
  const { enqueueSnackbar } = useSnackbar();
  const queryClient = useQueryClient();

  const addInvoiceMutation = useMutation<AddCostInvoiceBatchResponse, unknown, AddInvoiceBatchRequest>({
    mutationFn: (request) => addInvoiceToCosts(request),
    onSuccess: async (response) => {
      enqueueSnackbar(`Faktura ${response.name} została dołączona do ${response.costs.length} kosztów`, {
        variant: "success",
      });
      await queryClient.invalidateQueries({ predicate: (q) => isDataRangeQuery(q.queryKey) });
    },
    onError: (error) => {
      enqueueSnackbar(`Nie udało się dodać faktury. Powód: ${(error as Error).message}`, {
        variant: "error",
      });
    },
  });
  return {
    addInvoiceToCosts: (request: AddInvoiceBatchRequest) => addInvoiceMutation.mutateAsync(request),
  };
};

function isDataRangeQuery(queryKey: QueryKey): boolean {
  if (queryKey[0] !== "costs") {
    return false;
  }
  if (typeof queryKey[1] === "object" && !!(queryKey[1] as { from?: string }).from) {
    return true;
  }
  return false;
}
